import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

const excludedPathFragments: string[] = [
    '/project/new',
    '/user/new',
    '/customer/new',
    '/order/new',
    '/service/new',
    '/consultation/new',
    '/issue/new',
    '/worklog/new',
    '/worklogdetails/new',
    '/projectstep',
    '/login'
];

@Injectable()
export class RoutingHistoryService {
    readonly previousPathKey = 'PreviousVisitedPath';

    private previousUrl: string;
    private currentUrl: string;

    constructor(
        private router: Router
    ) {}

    public loadRouting(): void {
        this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(({urlAfterRedirects}: NavigationEnd) => {
            this.previousUrl = this.currentUrl;
            this.currentUrl = urlAfterRedirects;
            if(this.previousUrl
            && this.previousUrl != 'login'
            && !this.previousUrl.startsWith('/changepassword')
            && !this.previousUrl.startsWith('/resetpassword')
            && !this.isPathExcluded(this.previousUrl)) {
                localStorage.setItem(this.previousPathKey, this.previousUrl);
            }
        });
    }

    public getPreviousUrl(): string {
        return this.previousUrl || '/dashboard';
    }

    public getCurrentUrl(): string {
        return this.currentUrl || '/dashboard';
    }

    private isPathExcluded(path: string):boolean {
        for (let index = 0; index < excludedPathFragments.length; index++) {
            if(path.includes(excludedPathFragments[index])){
                return true;
            }
        }

        return false;
    }
}